// extracted by mini-css-extract-plugin
export default {"icon":"ExternalLink_icon__d5wMz"};